import request from "@/utils/request";
export default {
  getUnitList: (data) => {
    return request({
      url: "/unit-of-account/query",
      method: "post",
      data: data,
    });
  },
  queryGroups: (data) => {
    return request({
      url: "/unitOfAccountGroup/queryGroups",
      method: "post",
      data: data,
    });
  },
  saveGroups: (data) => {
    return request({
      url: "/unitOfAccountGroup/saveGroups",
      method: "post",
      data: data,
    });
  },
  getUnitOfAccounts: (data) => {
    return request({
      url: "/unitOfAccountGroup/getUnitOfAccounts",
      method: "post",
      data: data,
    });
  },
  checkUnitGropNo: (data, unitGroupNo) => {
    return request({
      url: `/unitOfAccountGroup/checkUnitGropNo/${unitGroupNo}`,
      method: "post",
      data: data,
    });
  },
  deleteGroups: (data) => {
    return request({
      url: "/unitOfAccountGroup/deleteGroups",
      method: "post",
      data: data,
    });
  },
  delUnitOfAccounts: (data) => {
    return request({
      url: "/unitOfAccountGroup/delUnitOfAccounts",
      method: "post",
      data: data,
    });
  },
  save: (data) =>
    request({
      url: `unit-of-account/save`,
      method: "post",
      data: data,
    }),
  submit: (data) =>
    request({
      url: `unit-of-account/submit`,
      method: "post",
      data: data,
    }),
  getDetail: (id, hasHistory = "N") => {
    return request({
      url: `unit-of-account/queryAccountUnitInfo/${id}/${hasHistory}`,
      method: "get",
    });
  },
  getAddress: (data, id) => {
    return request({
      url: `unit-of-account-address/queryAccountUnitAddressOptional/${id}`,
      method: "post",
      data: data,
    });
  },
  getAccountUnitAddress: (id) => {
    return request({
      url: `unit-of-account-address/queryAccountUnitAddressInfo/${id}`,
      method: "get",
    });
  },
  approval: (data) =>
    request({
      url: `unit-of-account/complete`,
      method: "post",
      data: data,
    }),
  getLawFile: (id) => {
    return request({
      url: `law-file/queryLawFileByTmSupplierId/${id}`,
      method: "get",
    });
  },
  //删除结算单位
  deleteUnit: (id) => {
    return request({
      url: `unit-of-account/delete/${id}`,
      method: "get",
    });
  },
  //归档
  pigeonhole: (tmLawFileId) => {
    return request({
      url: `law-file/pigeonhole/${tmLawFileId}`,
      method: "get",
    });
  },
  sendToMDM: (tmSupplierId) => {
    return request({
      url: `unit-of-account/sendMDM/${tmSupplierId}`,
      method: "get",
    });
  },
  getDefaultPickupPointOfPlant(tmPlantId) {
    return request({
      url: `unit-of-account-address/getDefaultPickupPointOfPlant`,
      method: "get",
      params: {
        tmPlantId: tmPlantId,
      },
    });
  },
  //撤回
  withdraw: (id) => {
    return request({
      url: `unit-of-account/recall/${id}`,
      method: "get",
    });
  },
  // 工厂编码修改
  editPlantCode: (data) => {
    return request({
      url: `unit-of-account/plantCode`,
      method: "post",
      data: data,
    });
  },
};